import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateList',
    standalone: true,
    pure: true
})
export class TranslateListPipe implements PipeTransform {
    constructor(private readonly translate: TranslateService) {}

    transform(keys: string[] | ValidationErrors | null, isErrorList: boolean = false): string[] {
        if (!keys) {
            return [];
        }

        let parsedKeys: string[];
        if (isErrorList) {
            parsedKeys = Object.values(keys);
        } else {
            parsedKeys = keys as string[];
        }

        if (!parsedKeys.length) {
            return [];
        }
        return parsedKeys.map(key => this.translate.instant(key));
    }
}
